/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.User | undefined }) {
  const { currentUser } = initialState || {};
  let hasRoutes = localStorage.getItem('menu') || '[]';
  hasRoutes = JSON.parse(hasRoutes);
  return {
    canAdmin: currentUser && currentUser.roleName === '管理员',
    normalRouteFilter: (route: any) => hasRoutes.includes(route.name), // initialState 中包含了的路由才有权限访问
  };
}